import { createClient } from '@supabase/supabase-js';

// Read-only client for the EDITOR's Supabase project (groundworkdb), which owns
// the world data (clubs, players, badges). The marketing site uses this only to
// read the public `public_clubs` view. Separate from the main app client
// (src/lib/supabaseClient.js), which points at the game project for auth/waitlist.
//
// Needs these vars in .env.local (and in Netlify):
//   REACT_APP_DB_SUPABASE_URL
//   REACT_APP_DB_SUPABASE_ANON_KEY

const url = process.env.REACT_APP_DB_SUPABASE_URL;
const key = process.env.REACT_APP_DB_SUPABASE_ANON_KEY;

// persistSession:false so this client never touches the auth session that the
// main game client stores on the same origin.
export const dbSupabase = url && key
  ? createClient(url, key, { auth: { persistSession: false, autoRefreshToken: false } })
  : null;

export const dbConfigured = Boolean(url && key);
